<template>
	<div v-if="isVisible" class="px-4 formField">
		<v-menu v-model="menu"
				:close-on-content-click="false"
				:nudge-right="40"
				transition="scale-transition"
				offset-y
				min-width="auto">
			<template v-slot:activator="{ on, attrs }">
				<v-text-field :disabled="formField.Readonly"
							  @keyup="uppercase"
							  :class="getUppercaseClass"
							  :rules="validationRules"
							  :error-messages="validationError"
							  :label="formField.Label"
							  hide-details="auto"
							  v-model="dateValue"
							  :placeholder="dateFormat"
							  prepend-icon="mdi-calendar"
							  clearable
							  v-bind="attrs"
							  v-on="on"
							  @click:prepend="menu = !menu">
					<template v-slot:append-outer v-if="canRetainValue">
						<v-icon v-if="!hasRetainedValue" @click="onPinClick">mdi-pin-off-outline</v-icon>
						<v-icon v-else
								color="primary"
								class="rotate45"
								@click="onPinClick">mdi-pin-outline</v-icon>
					</template>
					<template v-slot:prepend v-if="visibleBubble || visibleHelp">
						<div v-if="visibleBubble">
							<v-tooltip top
									   nudge-top="20"
									   :open-on-click="true"
									   :open-on-focus="true"
									   :open-on-hover="true">
								<template v-slot:activator="{ on, attrs }">
									<v-icon color="primary"
											v-bind="attrs"
											v-on="on"
											tabindex="-1">mdi-information-outline</v-icon>
								</template>
								{{ bubbleText }}
							</v-tooltip>
						</div>
						<div v-if="visibleHelp">
							<v-tooltip top
									   nudge-top="20"
									   :open-on-click="true"
									   :open-on-focus="true"
									   :open-on-hover="true">
								<template v-slot:activator="{ on, attrs }">
									<v-icon color="primary"
											v-bind="attrs"
											v-on="on"
											tabindex="-1">mdi-help-circle-outline</v-icon>
								</template>
								{{ helpText }}
							</v-tooltip>
						</div>
					</template>
				</v-text-field>
			</template>
			<v-date-picker v-model="pickerDate"
						   @input="menu = false"></v-date-picker>
		</v-menu>
	</div>
</template>
<script>
	import formFieldMixin from '../../../../mixins/inventoryForm/formFieldMixin';
	import projectSettingsMixin from '../../../../mixins/projectSettingsMixin';
	import fieldsValidationRules from '../../../../utils/fieldsValidationRules';
	import moment from 'moment';

	export default {
		name: 'DateField',
		mixins: [formFieldMixin, projectSettingsMixin],
		computed: {
			validations() {
				return fieldsValidationRules;
			},
			pickerDate: {
				get() {
					if (!this.selectedValue) return null;
					const date = moment.utc(this.selectedValue);
					return date.isValid() ? date.format('YYYY-MM-DD') : null;
				},
				set(val) {
					if (val) {
						this.selectedValue = moment.utc(val).format('YYYY-MM-DD');
						this.dateValue = this.getDateFormat(this.selectedValue);
					} else {
						this.selectedValue = null;
						this.dateValue = null;
					}
					this.onSelectedValueChanged(this.selectedValue);
				},
			},
		},
		data() {
			return {
				dateValue: null,
				menu: false,
			};
		},

		watch: {
			dateValue(newVal) {
				if (!newVal) {
					this.selectedValue = null;
					return;
				}

				let dateValue = moment.utc(newVal, this.getDateFormatProjectSetting());
				if (dateValue.isValid()) {
					this.selectedValue = dateValue.format('YYYY-MM-DD');
				}
			},
		},
		mounted() {
			this.defaultRules.push((v) =>
				this.validations.validationDateNullable(
					v,
					this.getDateFormatProjectSetting()
				)
			);
			this.defaultRules.push((v) => {
				if (this.formField.Required && !this.isBulkEdit) {
					if (!v) return false || 'The value is required';
					else return true;
				} else return true;
			});
			if (this.recordSelectedValue) {
				this.selectedValue = this.recordSelectedValue;
				this.dateValue = this.getDateFormat(this.recordSelectedValue);
			}
		},
		methods: {
			onRecordChanged() {
				if (
					this.recordSelectedValue &&
					this.selectedValue != this.recordSelectedValue
				) {
					this.selectedValue = this.recordSelectedValue;
					this.dateValue = this.getDateFormat(this.recordSelectedValue);
					return;
				}

				if (
					this.selectedValue &&
					this.selectedValue != this.recordSelectedValue
				) {
					this.selectedValue = null;
					this.dateValue = null;
				}
			},
			onHideFormField() {
				this.selectedValue = null;
				this.dateValue = null;
			},
			onSelectedValueChanged(newVal) {
				this.skipNextRecordUpdate = true;
				this.$emit('selectedValueChanged', [
					{ key: this.recordKeys[0], value: newVal },
				]);
			},
			onSetInteraction(setValue) {
				this.onSelectedValueChanged(setValue);
			},
			onClearInteraction() {
				this.onSelectedValueChanged(null);
			},
		},
	};
</script>
